import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SearchZeroResultsHelp } from './SearchZeroResultsHelp';
import {
  ZeroResultsContainer,
  ZeroResultsMain,
  ZeroResultsTitle,
} from './ZeroDecisionLib';
import { SearchTypes } from '../../search.types';

const LABEL_TYPE_MAP = {
  commentary: 'app.pages.search.zeroResults.types.commentary',
  law: 'app.pages.search.zeroResults.types.law',
  lawyer: 'app.pages.search.zeroResults.types.lawyer',
  enterprise: 'app.pages.search.zeroResults.types.enterprise',
} as const;

type Props = {
  searchType: Exclude<SearchTypes, 'arret'>;
};

export const ZeroCommonResults: FC<Props> = ({ searchType }) => (
  <ZeroResultsContainer>
    <ZeroResultsMain>
      <ZeroResultsTitle>
        <FormattedMessage id={LABEL_TYPE_MAP[searchType]} />
      </ZeroResultsTitle>
      <SearchZeroResultsHelp searchType={searchType} />
    </ZeroResultsMain>
  </ZeroResultsContainer>
);
